import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSDM18SP2 extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 300 173.33" height={size}>
                <g fill={color}>
                    <path
                        d="M285,78.33V221.67H15V78.33H285m5-15H10a10,10,0,0,0-10,10V226.67a10,10,0,0,0,10,10H290a10,10,0,0,0,10-10V73.33a10,10,0,0,0-10-10Z"
                        transform="translate(0 -63.33)"
                    />
                    <path d="M290,117.5v65H10v-65H290m10-10H0v85H300v-85Z" transform="translate(0 -63.33)" />
                    <path d="M290,102.5v95H10v-95H290m10-10H0v115H300V92.5Z" transform="translate(0 -63.33)" />
                    <path d="M195,124.75a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z" transform="translate(0 -63.33)" />
                    <path d="M208,124.75a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z" transform="translate(0 -63.33)" />
                    <path d="M221,124.75a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z" transform="translate(0 -63.33)" />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgSDM18SP2);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSDM18SP2.js